import { Button, Checkbox, Form, Input, Select, Space } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { requiredField } from "../common/common";

export const fieldTypes = [
  { value: "STRING", label: "Testo" },
  { value: "EMPLOYEES", label: "Dipendenti" },
  { value: "EMPLOYEE", label: "Dipendente" },
  { value: "VEHICLES", label: "Veicoli" },
  { value: "VEHICLE", label: "Veicolo" },
  { value: "BOOLEAN", label: "Sì / No" },
];

export default function PosModelFields() {
  return (
    <>
      <Form.Item label="Nome" name="name" rules={[requiredField]}>
        <Input />
      </Form.Item>
      <Form.List
        name="formItems"
        rules={[
          {
            validator: (_, items = []) => {
              const names = items.map((x) => x?.name).filter(Boolean);
              return new Set(names).size === names.length
                ? Promise.resolve()
                : Promise.reject(new Error("I nomi dei campi devono essere univoci"));
            },
          },
        ]}
      >
        {(fields, { add, remove }, { errors }) => (
          <>
            <p>Campi del modello</p>
            {fields.map(({ key, name, ...rest }) => (
              <div key={key}>
                <Space align="baseline" wrap>
                  <Form.Item {...rest} name={[name, "label"]} rules={[requiredField]}>
                    <Input placeholder="Titolo campo" />
                  </Form.Item>
                  <Form.Item {...rest} name={[name, "name"]} rules={[requiredField]}>
                    <Input placeholder="Valore campo" />
                  </Form.Item>
                  <Form.Item {...rest} name={[name, "type"]} rules={[requiredField]}>
                    <Select options={fieldTypes} placeholder="Tipo" style={{ width: 180 }} />
                  </Form.Item>
                  <Form.Item
                    {...rest}
                    name={[name, "fillWithAi"]}
                    valuePropName="checked"
                    initialValue={false}
                    rules={[requiredField]}
                  >
                    <Checkbox /> Precompila con AI
                  </Form.Item>
                  <Button
                    icon={<DeleteOutlined />}
                    onClick={() => remove(name)}
                    aria-label="Rimuovi campo"
                  />
                </Space>
              </div>
            ))}
            <Form.Item>
              <Button icon={<PlusOutlined />} onClick={() => add({ type: "STRING" })}>
                Aggiungi campo
              </Button>
              <Form.ErrorList errors={errors} />
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item label="Sezioni" name="sections">
        <Select mode="tags" tokenSeparators={[","]} placeholder="Inserisci i nomi delle sezioni" />
      </Form.Item>
    </>
  );
}
